import * as React from 'react';

const SvgListViewOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M3.75 5.082a.75.75 0 0 0 0 1.5h16.339a.75.75 0 1 0 0-1.5zm0 4.5a.75.75 0 1 0 0 1.5h16.339a.75.75 0 1 0 0-1.5zM3 14.832a.75.75 0 0 1 .75-.75h16.339a.75.75 0 1 1 0 1.5H3.75a.75.75 0 0 1-.75-.75m.75 3.75a.75.75 0 0 0 0 1.5h16.339a.75.75 0 1 0 0-1.5z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgListViewOutlined;
